<script>
    import uniq from 'lodash/uniq';
    import compact from 'lodash/compact';

    export let size = 'default'
    export let type = 'default'
    export let roundType = 'default'
    export let disabled = false

    $: classes = uniq(compact([size, type, roundType, $$props.class])).join(' ')
</script>

<button disabled="{disabled}" class={classes} on:click>
    <slot/>
</button>

<style>
    button {
        border-radius: 100px;
        color: #FFFFFF;
        background-color: #1ab394;
        border-color: #1ab394;
        padding: 12px 23px;
        font-size: 14px;
        cursor: pointer;
        transition: .2s;
    }

    button[disabled] {
        opacity: .5;
        cursor: default;
        pointer-events: none;
    }

    button:hover {
        background: #48c2a9;
        border-color: #48c2a9;
    }

    button:active {
        background: #17a185;
        border-color: #17a185;
        color: #FFFFFF;
        outline: none;
    }

    .danger {
        background-color: #f56c6c;
        border-color: #f56c6c
    }

    .danger:hover {
        background: #f78989;
        border-color: #f78989;
    }

    .danger:active {
        background: #dd6161;
        border-color: #dd6161;
    }

    .medium {
        padding: 10px 20px;
        font-size: 14px;
    }

    .small {
        padding: 9px 15px;
        font-size: 12px;
    }

    .mini {
        padding: 7px 15px;
        font-size: 12px;
    }

    .round {
        border-radius: 8px;
    }

    .round.small {
        border-radius: 6px;
    }

    .round.mini {
        border-radius: 4px;
    }

    .circle {
        padding: 0;
        border-radius: 100%;
        width: 42px;
        height: 42px;
    }

    .circle.medium {
        width: 38px;
        height: 38px;
    }

    .circle.small {
        width: 33px;
        height: 33px;
    }

    .circle.mini {
        width: 29px;
        height: 29px;
    }
</style>
